import { render, staticRenderFns } from "./RequestPenarikanBarang.vue?vue&type=template&id=416058e8&"
import script from "./RequestPenarikanBarang.vue?vue&type=script&lang=js&"
export * from "./RequestPenarikanBarang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports